module.exports = __webpack_public_path__ + "img/Pic_Sy_Team_b.7617fc67.png";